{
  "created": "Propiedad creada con éxito.",
  "updated": "Propiedad actualizada con éxito.",
  "removed": "Propiedad eliminada con éxito.",
  "remove-property": "Eliminar propiedad",
  "remove-confirmation": "¿Estás seguro de que quieres eliminar la propiedad?",
  "earnest-money":"Dinero en Garantía",
  "hard-remove-confirmation": "Los pagos de hipotecas, préstamos e impuestos asociados a esta propiedad serán eliminados, ¿está seguro de que desea eliminar la propiedad?\nLa eliminación puede llevar algún tiempo",
  "selling-commission":"Comisión de Venta",
  "listing-commission":"Comisión de Cotización",
  "selling-commission-percent":"Porcentaje de Comisión de Cotización",
  "listing-commission-percent":"Porcentaje de Comisión de Cotización",
  "accounting-entries-updated":"Registros contables actualizados",
  "error-delete-proration": "Error inesperado al intentar eliminar el prorrateo",
  "error-delete-mortgage": "Error inesperado al intentar eliminar el pago de hipoteca",
  "error-delete-loan": "Error inesperado al intentar eliminar el préstamo",
  "property-must-be-created-first": "La propiedad debe ser creada primero",
  "provide-required-info": "Por favor proporcione toda la información requerida."
}
